import styles from './ChartWrapper.module.css'
export const ChartWrapper = ({children}) => 
<div className={styles.svgChartContainer}>{children}</div>;
    
